var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShowBox || _vm.onlyShowAtinput,
          expression: "isShowBox || onlyShowAtinput"
        }
      ],
      staticClass: "atArea"
    },
    [
      _c(
        "div",
        {
          staticClass: "atInputWrapper",
          class: _vm.onlyShowAtinput ? "atTextarea" : "atReplyarea"
        },
        [
          _c("div", { staticClass: "input_box" }, [
            _c(
              "div",
              {
                ref: "refAtInput",
                class: [
                  "atInput",
                  "atInput" + _vm.atInputUniqueId,
                  { red_border: _vm.isShowTips }
                ],
                attrs: {
                  contenteditable: "true",
                  oncontrolselect: "return false",
                  spellcheck: "false"
                },
                on: {
                  keydown: function($event) {
                    return _vm.keydownAtInput($event)
                  },
                  keyup: function($event) {
                    return _vm.keyupAtInput($event)
                  },
                  click: _vm.click
                }
              },
              [_vm._m(0)]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "input_control",
                style: {
                  color: _vm.maxInputNum - _vm.atInputTextNum < 0 ? "red" : ""
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.atInputTextNum) +
                    "/" +
                    _vm._s(_vm.maxInputNum) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            !_vm.atInputTextNum
              ? _c(
                  "div",
                  {
                    staticClass: "placeholder",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return (function() {
                          return _vm.refAtInput.focus()
                        })($event)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.atPlaceholder) + "\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isShowTips,
                    expression: "isShowTips"
                  }
                ],
                staticClass: "required_tips"
              },
              [_vm._v(_vm._s(_vm.updateTipText))]
            )
          ])
        ]
      ),
      _vm._v(" "),
      !_vm.onlyShowAtinput
        ? _c("div", { staticClass: "button_area" }, [
            _c(
              "div",
              { staticClass: "cancle", on: { click: _vm.initAtInputArea } },
              [_vm._v(_vm._s(_vm.getLangMsg("commRecord_cancel")))]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "submit", on: { click: _vm.submitReply } },
              [_vm._v(_vm._s(_vm.getLangMsg("commRecord_release")))]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.state.visible,
              expression: "state.visible"
            }
          ],
          class: "atPopover " + "atPop" + _vm.atInputUniqueId,
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "atSelect_area",
              on: {
                keydown: function($event) {
                  return _vm.keydownPeopleList($event)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "people_search" },
                [
                  _c("el-input", {
                    ref: "refSearchInput",
                    attrs: {
                      size: "mini",
                      placeholder: _vm.getLangMsg("commRecord_key005"),
                      "prefix-icon": "kdfont kdfont-f"
                    },
                    on: { input: _vm.searchPeople },
                    model: {
                      value: _vm.searchText,
                      callback: function($$v) {
                        _vm.searchText = $$v
                      },
                      expression: "searchText"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "people_list",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.loading_list &&
                            _vm.peopleAtList &&
                            _vm.peopleAtList.length === 0,
                          expression:
                            "!loading_list && peopleAtList && peopleAtList.length === 0"
                        }
                      ],
                      staticClass: "noData_tip"
                    },
                    [_vm._v(_vm._s(_vm.getLangMsg("commRecord_key006")))]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.peopleAtList, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass: "people_at_item",
                        class: { isSelect: index === _vm.peopleCurIndex },
                        on: {
                          mouseenter: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            _vm.peopleCurIndex = index
                          },
                          click: function($event) {
                            return _vm.select(item)
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(item.name) +
                              "（" +
                              _vm._s(item.number) +
                              "）"
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(item.email))])
                      ]
                    )
                  })
                ],
                2
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("br")])
  }
]
render._withStripped = true

export { render, staticRenderFns }